import React from "react";
import { Box, Card, CardContent, Typography, Skeleton, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export const InstructionsCard = ({ pages, downloadPdf, t }) => (
  <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
    <Card elevation={0} sx={{ border: "1px solid #dfdfdf", borderRadius: 2 }}>
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
            {t.instructionsTitle}
          </Typography>
          {downloadPdf && pages.length > 0 && (
            <Button
              size="small"
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={downloadPdf}
              sx={{ borderColor: "#163666", color: "#163666", borderRadius: 1.5, flexShrink: 0 }}
            >
              {t.download}
            </Button>
          )}
        </Box>

        {pages.length === 0 ? (
          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
            <Skeleton variant="rectangular" sx={{ flex: 1, height: 300, borderRadius: 1 }} />
            <Skeleton variant="rectangular" sx={{ flex: 1, height: 300, borderRadius: 1 }} />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {pages.map((src, idx) => (
              <Box
                key={idx}
                component="img"
                src={src}
                alt={`Instruction Page ${idx + 1}`}
                sx={{
                  width: { xs: "100%", sm: "calc(50% - 8px)" },
                  borderRadius: 1,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  display: "block",
                }}
              />
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  </Box>
);
